﻿import React, {JSX, useMemo} from "react";
import {useControlId} from "../helpers/useControlId";
import {HtmlControlProps} from "./HtmlControlProps";

export type CheckboxProps = HtmlControlProps<HTMLInputElement> & {
	hint?: string,
	checked?: boolean;
};

export default function Checkbox(props: CheckboxProps): JSX.Element {
	const {
		label,
		name,
		value,
		id,
		column,
		disabled,
		hidden,
		onChange,
		onBlur,
		ref,
		hint,
		checked
	} = props;

	const controlId = useControlId(id);
	const hintId = controlId + "-hint";
	const hasHint = hint != null;
	const klass = useMemo(() => "labelled-field" + (column ? ` ${column}` : ""), [column]);

	if (hidden) {
		return <></>;
	}

	return (
		<div className={klass}>
			<div className="form__field form__field--checkbox">
				<input type="checkbox"
				       ref={ref}
				       id={controlId}
				       name={name}
				       onChange={onChange}
				       onBlur={onBlur}
				       value={value}
				       tabIndex={disabled ? -1 : undefined}
				       readOnly={disabled}
				       checked={onChange == null ? undefined : checked}
				       defaultChecked={onChange == null ? checked : undefined}/>
				<label className="checkbox__label" htmlFor={controlId}>
					<span className="label__text">{label}</span>
				</label>
				{hasHint && <span id={hintId} className="field__hint">{hint}</span>}
			</div>
		</div>
	);
}
